<div class="w-full py-3 px-4">
  <!-- Title Section -->
  <div class="sm:flex items-center justify-between mb-4 gap-4">
    
    <!-- Left Title -->
    <div class="flex items-center gap-2 mb-2 sm:mb-0">
      <svg
        class="size-6 cursor-pointer"
        [routerLink]="['/home']"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z"
          fill="#C19725"
        />
      </svg>

      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">
        Categories
      </span>
    </div>

    <!-- Tabs -->
    <div class="overflow-x-auto scrollbar-hide">
      <div
        class="grid grid-cols-3 min-w-[360px] sm:min-w-[420px] lg:min-w-[480px] border border-[#D9D9D9] rounded-md overflow-hidden"
      >
        <!-- Categories -->
        <a
          routerLink="add-category"
          routerLinkActive="bg-c19725 text-white font-medium"
          [routerLinkActiveOptions]="{ exact: true }"
          class="text-center px-4 py-2 text-[#898989] text-sm lg:text-base hover:bg-[#f6f1cb] transition"
        >
          Categories
        </a>

        <!-- Sub Categories -->
        <a
          routerLink="sub-category"
          routerLinkActive="bg-c19725 text-white font-medium"
          class="text-center px-4 py-2 text-[#898989] text-sm lg:text-base hover:bg-[#f6f1cb] transition border-l border-r border-[#D9D9D9]"
        >
          Sub Categories
        </a>

        <!-- Assembly Brands -->
        <a
          routerLink="assembly_brand"
          routerLinkActive="bg-c19725 text-white font-medium"
          class="text-center px-4 py-2 text-[#898989] text-sm lg:text-base hover:bg-[#f6f1cb] transition"
        >
          Assembly Brands
        </a>
      </div>
    </div>
  </div>

  <router-outlet />
</div>
